import React from "react";
import { Link } from "react-router-dom";

const Pharmacytabs = () => {
	return (
		<>
			<div className="row">
				<div className="col-lg-12">
					<ul className="all-tabs">
						<li className="d-flex align-items-center gap-3">
							<Link to="/prescription-orders-all" className="black-all">
								all
							</Link>
							<Link to="/prescription-orders-Panding" className="black-pending">
								Pending
							</Link>
							<Link
								to="/prescription-orders-inprogress"
								className="black-progress"
							>
								In Progress
							</Link>
							<Link
								to="/prescription-orders-complete"
								className="black-complete border-colorful"
							>
								Completed
							</Link>
						</li>
					</ul>
				</div>
			</div>
		</>
	);
};

export default Pharmacytabs;
